import Modal from 'react-modal';

function PopUpModal({ errorMsg, isModalOpen, setIsModalOpen }) {
    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };
    
    const closeModal = () => {
        setIsModalOpen(false);
    }
    Modal.setAppElement('#root');
    return (
        <Modal
            isOpen={isModalOpen}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
        >
            <div className='pop-up-modal'>
                <h3 style={{color: 'red'}}>Unexpected Error Occurred</h3>
                <h4>{errorMsg}</h4>
                <button className='modal-close-btn' onClick={closeModal}>close</button>
            </div>
            
        </Modal>
    );
}

export default PopUpModal;